<template>
    <div id="info-container" style="width: 50vw; min-width: 350px;">
        <div>
            <!-- <p class="section-title">{{ $t('DismissAlarms') }}</p> -->
            <div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td >
                            <p class="info-field-title">{{ $t('Annotation') }}</p>
                        </td>
                        <td class="info-field-value">
                            <textarea v-model="annotation" type="text" :placeholder="$t('Annotation')"/>
                        </td>
                    </tr>
                </div>
                <div>
                    <div class="error" v-if="error != ''">{{ error }}</div>
                </div>
            </div>
        </div>
        <div style="align-self: center;">
            <Button :title="$t('Save')" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" @onClick="dismiss"></Button>
        </div>
    </div>
</template>

<script>
import { dismissAlarms, dismissManyAlarms } from '../../api/api';
import Button from '../Button.vue';

export default {
    props: {
        isMany: {
            required: false,
            default: false,
            type: Boolean
        },
        isGroup: {
            required: false,
            default: false,
            type: Boolean
        },
        toDismiss: {
            required: true
        },
        systemId: {
            type: String,
            required: true
        }
    },
    components: {
        Button
    },
    data() {
        return {
            annotation: '',
            error: ''
        }
    },
    methods: {
        dismiss() {
            let objToSend = {
                Annotation: this.annotation,
                AlarmsId: [],
                AlarmTypeId: -1
            }
            if (this.isMany) {
                for(let i = 0; i < this.toDismiss.length; i++) {
                    if(this.toDismiss[i].nestedAlarms != null) {
                        objToSend.AlarmsId.push(...this.toDismiss[i].nestedAlarms.map(m => m.id))
                    } else {
                        objToSend.AlarmsId.push(this.toDismiss[i].id)
                    }
                }
            } else if (this.isGroup) {
                objToSend.AlarmsId.push(this.toDismiss.id)
                objToSend.AlarmTypeId = this.toDismiss.alarmTypeId
            } else {
                if (this.toDismiss.nestedAlarms != null) {
                    objToSend.AlarmsId.push(...this.toDismiss.nestedAlarms.map(m => m.id))
                    objToSend.AlarmTypeId = this.toDismiss.alarmTypeId
                } else {
                    objToSend.AlarmsId.push(this.toDismiss.id)
                    objToSend.AlarmTypeId = this.toDismiss.alarmTypeId
                }
            }

            if(this.isMany){
                dismissManyAlarms(this.systemId, objToSend).then(() => {
                    this.$emit('dismissed')
                }).catch(err => {
                    this.error = err.response.data.error
                })
            } else {
                dismissAlarms(this.systemId, objToSend).then(() => {
                    this.$emit('dismissed')
                }).catch(err => {
                    this.error = err.response.data.error
                })
            }
            

        }
    },
    mounted() {

    }
}
</script>

<style scoped>
.error {
    text-align: left !important;
    color: #FD8282;
    font-size: 11px;
    font-weight: bold;
    font-family: 'Open Sans', sans-serif !important;
    font-style: normal !important;
    font-weight: 400 !important;
}

#info-container {
    padding: 20px;
    background: #FFFFFF;
    border: 1px solid #EFEFEF;
    box-sizing: border-box;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    border-radius: 5px 0px 0px 5px;
    justify-content: space-between;
    display: flex;
    flex-direction: column;
}

.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
    margin: 0;
}

.info-field-row {
    width: 100%;
    margin: 0;
    padding-bottom: 5px;
    display: grid;
    grid-template-columns: 30% 70%;
}

.info-field-value {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
}

.section-title {
    font-weight: bold;
}

textarea {
    border: none;
    width: 100%;
}

textarea:focus {
    border-bottom: 1px solid #0095b2;
    outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Systems/DismissAlarmModal.vue